var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.984,
    height: 29.737,
    viewBox: "0 0 33.984 29.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-from-bracket",
    d: "M10.62,57.489H6.372a2.124,2.124,0,0,1-2.124-2.124V38.372a2.124,2.124,0,0,1,2.124-2.124H10.62a2.124,2.124,0,1,0,0-4.248H6.372A6.372,6.372,0,0,0,0,38.372V55.365a6.372,6.372,0,0,0,6.372,6.372H10.62a2.124,2.124,0,0,0,0-4.248Zm22.741-12.12-8.5-8.5a2.124,2.124,0,0,0-3,3l4.875,4.869H12.744a2.124,2.124,0,0,0,0,4.248H26.736l-4.871,4.871a2.124,2.124,0,1,0,3,3l8.5-8.5A2.126,2.126,0,0,0,33.361,45.368Z",
    transform: "translate(0 -32)",
    fill: "#e93423"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d4ff306bf3edffa59cb170224c8b5efc.svg";
export { ForwardRef as ReactComponent };